import { render, staticRenderFns } from "./OperationDetail.template.vue?vue&type=template&id=22dc6e44&scoped=true&"
var script = {}
import style0 from "./OperationDetail.template.vue?vue&type=style&index=0&id=22dc6e44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc6e44",
  null
  
)

export default component.exports